module.exports = __webpack_public_path__ + "img/epl.64350691.svg";